import { Pipe, PipeTransform } from '@angular/core';
import { IUser } from "../../shared/models/user.model";
import { Observable } from 'rxjs/Observable';
import { AuthData } from '../../providers/auth';

@Pipe({
  name: 'userInfo'
})

export class UserInfoPipe implements PipeTransform {

  constructor(
    private authProvider: AuthData
  ) { }

  transform(value: string, clientId: string): Observable<IUser> {
    return this.authProvider.getUserDB(value, clientId);
  }
}


// WEBPACK FOOTER //
// ./src/pipes/user/user.info.ts